module.exports = __webpack_public_path__ + "static/globalwar_switz-1c69f686fc76858d3e72d75b268532ab.png";